export default {
    data: () => ({
        translations: {
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
            product: {
                el: "Προϊόν",
                en: "Product",
                it: "Prodotto"
            },
            totalPoints: {
                el: "Σύνολο Πόντων",
                en: "Total Points",
                it: "Punti totali"
            },
            funded: {
                el: "Με επιδότηση",
                en: "Funded",
                it: "Finanziato"
            },
            nonFunded: {
                el: "Χωρίς Επιδότηση",
                en: "Non Funded",
                it: "Non Finanziato"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            paymentMethod: {
                el: "Τρόπος Πληρωμής",
                en: "Payment Method",
                it: "Metodo di pagamento"
            },
            subsidized: {
                el: "Με επιδότηση",
                en: "Subsidized",
                it: "Sovvenzionato"
            },
            notSubsidized: {
                el: "Χωρίς Επιδότηση",
                en: "Not Subsidized",
                it: "Non Sovvenzionato"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
